import { Action } from 'redux'
import { put, takeLatest } from 'redux-saga/effects'
import axios from '@utils/request'
import { IOneProductPayload } from '@app-store/slices/products/oneProduct'
import { rootActions } from '@app-store/slices'

interface TaskAction extends Action {
    payload: IOneProductPayload
}

const { onRequest, onSuccess, onFailure } = rootActions.products.oneProduct

function* oneProductSagaTask({ payload }) {
    try {
        const response = yield axios.get(`/companies/products/one/${payload.productId}`)
        if (response.success) {
            yield put(onSuccess(response.result))
        } else {
            throw new Error('')
        }
    } catch (error) {
        yield put(onFailure(error))
    }
}

function* oneProductSaga(): any {
    yield takeLatest<TaskAction>(onRequest, oneProductSagaTask)
}

export default oneProductSaga
